import { render, staticRenderFns } from "./AccessRestrictedTabs.vue?vue&type=template&id=5e2e0e30&"
import script from "./AccessRestrictedTabs.vue?vue&type=script&lang=js&"
export * from "./AccessRestrictedTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports